import { Navigate, Route, Routes } from "react-router-dom";

import GuestOnly from "./middlewares/GuestOnly";

import GuestLayout from "layouts/GuestLayout";

import SignInScreen from "screens/Guest/SignInScreen";
import ForgotPasswordScreen from "screens/Guest/ForgotPasswordScreen";
import ResetPasswordScreen from "screens/Guest/ResetPasswordScreen";
import { NotFoundScreen } from "screens/NotFoundScreen";
import PrivacyPolicy from "screens/Guest/Privacypolicy";
import LandingScreen from "layouts/LandingPage";

import RegisterScreen from "screens/RegisterScreen";
import ServiceDetailScreen from "layouts/LandingPage/ServiceDetailScreen";
import TrackingShipment from "layouts/LandingPage/TrackingShipment";
import { ViewShipmentDetailByStatus } from "layouts/LandingPage/ViewShipmentDetailByStatus";
import BlogListScreen from "layouts/blogComponents/BlogListScreen";
import BlogDetailScreen from "layouts/blogComponents/BlogDetailScreen";
import RouteRoutineList from "layouts/LandingPage/RouteRoutine";
import RouteRoutineDetail from "layouts/LandingPage/RouteRoutineDetail";

const GuestRouter = () => {
  return (
    <Routes>
      <Route index element={<Navigate to={"/sign-in"} replace />} />
      <Route path="/" element={<GuestOnly component={LandingScreen} />} />
      <Route path="/home" element={<GuestOnly component={LandingScreen} />} />
      <Route path="/service-detail/:id" element={<ServiceDetailScreen />} />
      <Route path="/tracking" element={<TrackingShipment />} />
      <Route path="/routine" element={<RouteRoutineList />} />
      <Route path="/routine/:routeId" element={<RouteRoutineDetail />} />
      <Route
        path="/tracking/status/:id"
        element={<ViewShipmentDetailByStatus />}
      />
      <Route path="/blogs" element={<BlogListScreen />} />
      <Route path="/blog-detail/:slug" element={<BlogDetailScreen />} />
      {/* <Route path="/" element={<GuestOnly component={SignInScreen} />} /> */}
      <Route path="/sign-in" element={<GuestOnly component={SignInScreen} />} />
      <Route
        path="/register"
        element={<GuestOnly component={RegisterScreen} />}
      />
      <Route
        path="/forgot-password"
        element={<GuestOnly component={ForgotPasswordScreen} />}
      />
      <Route
        path="/reset-password"
        element={<GuestOnly component={ResetPasswordScreen} />}
      />
      <Route path="/public" element={<GuestLayout />}>
        <Route path="*" element={<NotFoundScreen />} />
      </Route>
      {/* privacy policy page added for mobile app review */}
      <Route path="/privacy" element={<GuestLayout />}>
        <Route index element={<PrivacyPolicy />} />

        <Route path="*" element={<NotFoundScreen />} />
      </Route>
      <Route path="*" element={<NotFoundScreen />} />
    </Routes>
  );
};

export default GuestRouter;
